import React, { FC, HTMLAttributes, RefCallback, RefObject } from 'react';
// @ts-ignore
import BrowserSymbol from 'svg-baker-runtime/browser-symbol';
// @ts-ignore
import { assign } from 'es6-object-assign';
import { addSpriteSymbol, useIsomorphicLayoutEffect } from '../sprite';
import { SvgIcon } from '../SvgIcon';

const viewBox = '0 0 8 12';
const id = 'online_mobile_12';
const content = '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 12" id="online_mobile_12"><path d="M2.01 0h3.98C7.1 0 8 .9 8 2.01v7.98C8 11.1 7.1 12 5.99 12H2.01C.9 12 0 11.1 0 9.99V2.01C0 .9.9 0 2.01 0zm-.007 3a.502.502 0 00-.503.502v4.996c0 .277.225.502.502.502h3.995a.502.502 0 00.503-.502V3.503A.502.502 0 005.997 3H2.003z" fill="currentColor" fill-rule="evenodd" /></symbol>';

let isMounted = false;
function mountIcon() {
  if (!isMounted) {
    addSpriteSymbol(new BrowserSymbol({
      id: id,
      viewBox: viewBox,
      content: content,
    }));

    isMounted = true;
  }
}

export interface Icon12OnlineMobileProps extends HTMLAttributes<HTMLDivElement> {
  fill?: string;
  width?: number;
  height?: number;
  getRootRef?: RefCallback<HTMLDivElement> | RefObject<HTMLDivElement>;
}

const Icon12OnlineMobile: FC<Icon12OnlineMobileProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    mountIcon();
  }, []);

  return React.createElement(SvgIcon, assign({}, props, {
    viewBox: viewBox,
    id: id,
    width: !isNaN(props.width) ? +props.width : 8,
    height: !isNaN(props.height) ? +props.height : 12,
  }));
};

(Icon12OnlineMobile as any).mountIcon = mountIcon;

export default Icon12OnlineMobile;
